module.exports = __webpack_public_path__ + "static/media/g_vu.65a5f999.png";